package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.credit_client


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListCreditClients(
    @SerialName("hasNextPage")
    val hasNextPage: Boolean?,
    @SerialName("items")
    val items: List<Item?>?,
    @SerialName("total")
    val total: Int?,
    @SerialName("__typename")
    val typename: String?
)